import React from "react";

const STATUSES = [
  { key: "new", label: "New", active: "bg-brand text-white" },
  { key: "contacted", label: "Contacted", active: "bg-amber-500 text-white" },
  { key: "won", label: "Won", active: "bg-emerald-500 text-white" },
];

// Segmented follow-up status control (New / Contacted / Won).
export function FollowUpStatus({ value, onChange }) {
  const current = value || "new";
  return (
    <div className="inline-flex rounded-full border border-line bg-white/[0.04] p-0.5" data-testid="follow-up-status" onClick={(e) => e.stopPropagation()}>
      {STATUSES.map((s) => {
        const active = current === s.key;
        return (
          <button key={s.key} data-testid={`status-${s.key}`}
            onClick={(e) => { e.stopPropagation(); if (!active) onChange(s.key); }}
            className={"px-2.5 py-1 text-[11px] font-medium rounded-full transition " + (active ? s.active : "text-mutedText hover:text-forest")}>
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
